import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/works", label: "影视作品" },
  { to: "/news", label: "资讯" },
  { to: "/characters", label: "角色解析" },
  { to: "/about", label: "关于" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? "text-accent-600"
        : "text-foreground-700 hover:text-primary-700"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-3 cursor-pointer shrink-0">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold text-lg">
              希
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading font-bold text-base md:text-lg text-foreground-950 whitespace-nowrap">
                希岛爱理
              </span>
              <span className="text-[10px] md:text-xs tracking-[0.25em] text-foreground-500 uppercase">
                Film Archive
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={submitSearch}
              className="hidden md:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 w-56 lg:w-64"
            >
              <i className="ri-search-line text-foreground-400 text-sm" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索作品 / 资讯 / 角色"
                className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
              />
              <button
                type="submit"
                className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-arrow-right-line text-sm" />
              </button>
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-3">
          <form
            onSubmit={submitSearch}
            className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 mb-4"
          >
            <i className="ri-search-line text-foreground-400 text-sm" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品 / 资讯 / 角色"
              className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50"
              aria-label="搜索"
            >
              <i className="ri-arrow-right-line text-sm" />
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `py-3 px-2 text-base border-b border-background-100 last:border-0 ${
                    isActive ? "text-accent-600 font-semibold" : "text-foreground-800"
                  }`
                }
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}